import {generateAsyncActionCreators} from '../core/reduxUtils';

const getUserInfoActionCreators = generateAsyncActionCreators(
  'GET_USER_INFO',
  (params) => ({
    params,
  })
);

const setUserInfoActionCreators = generateAsyncActionCreators(
  'SET_USER_INFO',
  (params) => ({
    params,
  })
);

const actionCreators = {
  // @todo delete this (unused)
  getUserInfo: {
    ...getUserInfoActionCreators,
  },

  setUserInfo: {
    ...setUserInfoActionCreators,
  },
};

export {
  actionCreators,
  getUserInfoActionCreators,
  setUserInfoActionCreators,
};
